import { useContext } from "react";
import TabContext from "../store/tab-context";
import css from "./Tab.module.css";

function Tab(props) {
  const tabContext = useContext(TabContext);

  var tabPositionRight =
    props.tabPosition === "right"
      ? tabContext.value === props.value
        ? css.startRightSlideLeft
        : css.startRightSlideRight
      : null;

  const tabPositionLeft =
    props.tabPosition === "left"
      ? tabContext.value === props.value
        ? css.startLeftSlideRight
        : css.startLeftSlideLeft
      : null;

  const leftBorderRadius = props.leftBorderRadius ? css.leftBorderRadius : null;
  const rightBorderRadius = props.rightBorderRadius
    ? css.rightBorderRadius
    : null;

  return (
    <div
      className={`
            ${css.tabButton} 
            ${tabPositionLeft}
            ${tabPositionRight}
            ${leftBorderRadius}
            ${rightBorderRadius}
          `}
      onClick={() => {
        tabContext.updateValue(props.value);
      }}
    >
      {props.children}
    </div>
  );
}

export default Tab;
